import api from "config/axios";

export const getSubTiersList = () => api.get("/sub-tiers");
